<template>
  <div class="flex justify-center">
    <slot />
  </div>
</template>